import React from "react";
const IconCell = _ref => {
  let {
    columnKey,
    cellData,
    mobileHeaderValue
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: "item-cell ".concat(columnKey, "-grid")
  }, mobileHeaderValue && /*#__PURE__*/React.createElement("div", {
    className: "head-cell-mobile mr-2"
  }, mobileHeaderValue), cellData.icon);
};
export default IconCell;